import { render } from "./TrafficSourceList.vue?vue&type=template&id=2104da7f&scoped=true"
import script from "./TrafficSourceList.vue?vue&type=script&lang=ts"
export * from "./TrafficSourceList.vue?vue&type=script&lang=ts"

import "./TrafficSourceList.vue?vue&type=style&index=0&id=2104da7f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2104da7f"

export default script
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh,QTd,QBtn,QSelect,QSpace});
